import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AppBody from "../../components/AppBody";
import { useDispatch, useSelector } from "react-redux";
import {
  getQuestionBank,
  addRandomQuestions,
  getLanguageIdentifeid,
  addAutomaticQuestions,
  getAssessmentQuestions
} from "../../../actions/learning_provider/question/question_bank_action";

const AddAssessmentQuestion = () => {
  const state = useSelector((state) => state.questionBankReducer);
  const dispatch = useDispatch("");
  const [searchText, setSearchText] = useState("");
  const { slug } = useParams();
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  const [assessment, setAssessment] = useState({
    minute: "",
    type: 1,
    slug: slug
  });

  const [assessmentAutomatic, setAssessmentAutomatic] = useState({
    type: "",
    languge_identified: "",
    beginner_question: "",
    intermediate_question: "",
    advanced_question: "",
    slug: slug
  });

  const [showAssessment, setShowAssessment] = useState(1);

  useEffect(() => {
    dispatch(getAssessmentQuestions({type:1,training_id:56}))
    dispatch(getQuestionBank());
    dispatch(getLanguageIdentifeid());
   

  }, []);

  const searchQuestion = () => {
    dispatch(getQuestionBank({ search: searchText }));
  };

  const addQuestionInList = (id) => {
    if (!selectedQuestions.includes(id)) {
      setSelectedQuestions([...selectedQuestions, id]);
    } else {
      setSelectedQuestions(selectedQuestions.filter((item) => item !== id));
    }
  };

  const removeSelectAllQuestion = () => {
    setSelectedQuestions([]);
  };

  const addAssessmentQuestions = () => {
    dispatch(
      addRandomQuestions({ ...assessment, question_ids: selectedQuestions })
    );
  };

  if (state.is_done) {
    dispatch(getQuestionBank({ search: searchText }));
    setSelectedQuestions([]);
  }

   const submitAutomaticQuestions=()=>{
       dispatch(addAutomaticQuestions(assessmentAutomatic))
   }


  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/all-trainings"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Add Questions In Assessment
              </h4>
              <div className="col text-right pr-0">
                <Link to={"/question-bank/add"}>
                  <a
                    className="line-height-36 custom-icon mr-2"
                    title="Add Question Bank"
                  >
                    <i className="feather-plus-circle"></i>
                  </a>
                </Link>
              </div>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <ul class="nav nav-tabs">
                <li class="active">
                  <a
                    data-toggle="tab"
                    href="#random"
                    aria-expanded="true"
                    onClick={() => setShowAssessment(1)}
                  >
                    Random Question Add
                  </a>
                </li>
                <li>
                  <a
                    data-toggle="tab"
                    href="#automatic"
                    onClick={() => setShowAssessment(2)}
                  >
                    Automatic Question Add
                  </a>
                </li>
              </ul>

              <div class="tab-content">
                {showAssessment === 1 ? (
                  <div class="tab-pane fade in active show" id="random">
                    <div className="row">
                      <div className="col-lg-4 mb-2">
                        <div className="form-group">
                          <label className="mont-font fw-600 font-xsss">
                            Add No Of Minutes
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="eg. 10, 15, 30"
                            onChange={(e) =>
                              setAssessment({
                                ...assessment,
                                minute: e.target.value
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 mb-2">
                        <div className="form-group">
                          <label className="mont-font fw-600 font-xsss">
                            Select Assessment Type
                          </label>
                          <select
                            className="form-control"
                            onChange={(e) =>
                              setAssessment({
                                ...assessment,
                                type: e.target.value
                              })
                            }
                          >
                            <option value="1">Pre-Assessment</option>
                            <option value="2">Post-Assessment</option>
                          </select>
                          <span className="error-msg"></span>
                        </div>
                      </div>
                      <div className="col-lg-4 mb-12">
                        <div className="form-group">
                          <br />
                          <button
                            className="btn-common px-5 mr-t-12"
                            onClick={() => addAssessmentQuestions()}
                          >
                            Add Questions
                          </button>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-lg-3 mb-3">
                        <button
                          className="btn  btn-common ad-serach-cer-btn px-5"
                          onClick={() => removeSelectAllQuestion()}
                        >
                          Remove All
                        </button>
                      </div>
                      <div className="col-lg-6 mb-3">
                        <input
                          type="text"
                          onChange={(e) => {
                            e.target.value
                              ? setSearchText(e.target.value)
                              : dispatch(getQuestionBank({ search: "" }));
                          }}
                          className="form-control ad-search-cer-tb"
                        />
                      </div>
                      <div className="col-lg-2 mb-3">
                        <button
                          type="button"
                          className="btn  btn-common ad-serach-cer-btn"
                          onClick={() => searchQuestion()}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sr.No</th>
                            <th>Select</th>
                            <th>Identified</th>
                            <th>Category</th>
                            <th>Question Type</th>
                            <th>Question</th>
                            <th>Correct Option</th>
                          </tr>
                        </thead>
                        <tbody>
                          {state.list &&
                            state.list.map((li, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-control assign-check"
                                    value={li.id}
                                    checked={
                                      selectedQuestions.includes(li.id)
                                        ? true
                                        : false
                                    }
                                    onChange={(e) => addQuestionInList(li.id)}
                                  />
                                </td>
                                <td>{li.language_identified}</td>
                                <td>{li.question_category}</td>
                                <td>{li.question_type}</td>
                                <td>{li.question}</td>
                                <td>{li.correct_option}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="">
                    <div class="tab-pane fade" id="automatic">
                      <h1>Assessment</h1>
                      <div className="row">
                        <div className="col-lg-6 mb-2">
                          <div className="form-group">
                            <select
                              className="form-control"
                              onChange={(e) =>
                                setAssessmentAutomatic({
                                  ...assessmentAutomatic,
                                  type: e.target.value
                                })
                              }
                            >
                              <option>Select Assessment</option>
                              <option value={1}>Pre-Assessment</option>
                              <option value={2}>Post-Assessment</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-2">
                          <div className="form-group">
                            <select
                              className="form-control"
                              onChange={(e) =>
                                setAssessmentAutomatic({
                                  ...assessmentAutomatic,
                                  languge_identified: e.target.value
                                })
                              }
                            >
                              <option>Select Language Identified</option>
                              {state &&
                                state.identifieds &&
                                state.identifieds.map((ind) => (
                                  <option value={ind.language_identified}>
                                    {ind.language_identified}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>                       
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-4 mb-2">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              Beginner Question
                            </label>
                            <input
                              placeholder="Total Beginner Question"
                              type="text"
                              className="form-control"
                              onChange={(e) =>
                                setAssessmentAutomatic({
                                  ...assessmentAutomatic,
                                  beginner_question: e.target.value
                                })
                              }
                            />
                            <span className="error-msg">
                              {state.beginner_question
                                ? state.errors.beginner_question
                                : ""}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-4 mb-2">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              Intermediate Question
                            </label>
                            <input
                              placeholder="Total Intermediate Question"
                              type="text"
                              className="form-control"
                              onChange={(e) =>
                                setAssessmentAutomatic({
                                  ...assessmentAutomatic,
                                  intermediate_question: e.target.value
                                })
                              }
                            />
                            <span className="error-msg">
                              {state.errors ? state.errors.name : ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-lg-4 mb-2">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              Advance Question
                            </label>
                            <input
                              placeholder="Total Advance Question"
                              type="text"
                              className="form-control"
                              onChange={(e) =>
                                setAssessmentAutomatic({
                                  ...assessmentAutomatic,
                                  advanced_question: e.target.value
                                })
                              }
                            />
                            <span className="error-msg">
                              {state.errors ? state.errors.name : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 my-3">
                        <input
                          type="button"
                          name="submit"
                          value="Submit"
                          className="btn-common px-5"
                          onClick={()=>submitAutomaticQuestions()}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AddAssessmentQuestion;
